var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPinGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.13 125.11C297.34 125.11 329.65 155.34 329.65 195.54C329.65 234.13 297.34 266.3 257.13 266.3C216.61 266.3 184.28 234.13 184.28 195.54C184.28 155.34 216.61 125.11 257.13 125.11V125.11ZM438.67 177.53C438.67 78.79 358 0 257.13 0C156.13 0 73.33 78.79 73.33 177.53C73.33 181.71 73.33 187.83 75.42 191.68H73.33C73.33 288.49 257.13 512 257.13 512C257.13 512 438.67 288.49 438.67 191.68V177.53V177.53Z",
    fill: "#91BE23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417 161.5C417 72.306 344.694 0 255.5 0C166.306 0 94 72.306 94 161.5C94 250.694 166.306 323 255.5 323C344.694 323 417 250.694 417 161.5Z",
    fill: "#91BE23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.548 109.846C269.93 109.846 246.976 132.431 246.976 161.5C246.976 181.33 231.873 196.459 212.263 196.459C192.655 196.459 177.766 181.33 177.766 161.5C177.766 141.67 192.87 126.542 212.263 126.542C224.212 126.542 234.462 132.161 240.666 141.022C242.661 135.187 245.52 129.811 249.053 124.975C239.668 115.601 226.667 109.873 212.263 109.873C183.646 109.846 160.692 132.431 160.692 161.5C160.692 190.569 183.646 213.154 212.263 213.154C230.335 213.154 246.222 204.158 255.473 190.191C264.671 204.131 280.477 213.154 298.548 213.154C327.165 213.154 350.308 190.569 350.308 161.5C350.308 132.431 327.165 109.846 298.548 109.846ZM298.548 196.459C279.127 196.459 264.05 181.33 264.05 161.5C264.05 141.67 279.155 126.542 298.548 126.542C317.941 126.542 333.261 141.67 333.261 161.5C333.261 181.33 318.157 196.459 298.548 196.459Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 323,
    height: 323,
    fill: "white",
    transform: "translate(94)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinGreen);
export default __webpack_public_path__ + "static/media/map_pin_green.7cb03daf1a012d10b6cb86ad320d42d4.svg";
export { ForwardRef as ReactComponent };